import React, { useState } from "react";
import { Spin } from "antd";
import { Redirect } from "react-router-dom";
import { compose } from "redux";
import { Form } from "antd";
import { connect } from "react-redux";
import {
  isLoaded,
  isEmpty,
  firestoreConnect,
  withFirestore
} from "react-redux-firebase";
import firebase from "firebase";
import "firebase/functions";

import Profile from "./Profile";
import {
  AddressFields as Fields,
  UsernameFields as UserField
} from "../common/labels/forms";
import ModalPopUp from "../common/ModalPopUp";

const Index = props => {
  const [modalVisible, setModalVisible] = useState(false);
  const [plan, setPlan] = useState({
    price: "",
    plan: "",
    stripePlan: "",
    checked: false
  });

  const [drawer, setDrawer] = useState({
    fields: "",
    visible: false,
    title: ""
  });

  const showDrawer = (fields, title) => {
    setDrawer({
      fields: fields,
      visible: true,
      title: title
    });
  };

  const onClose = () => {
    setDrawer({
      visible: false
    });
  };

  const planChart = plan => {
    if (plan === "starter") {
      setPlan({
        price: "9.99",
        plan: "Starter",
        stripePlan: "plan_Fg7MDm0AjoXoes",
        checked: true
      });
    } else if (plan === "pro") {
      setPlan({
        price: "15.00",
        plan: "Pro",
        stripePlan: "plan_Fg7ONqzhOUvKJl",
        checked: true
      });
    } else {
      setPlan({
        price: "19.99",
        plan: "Store",
        stripePlan: "plan_Fg7POKi5RBt95L",
        checked: true
      });
    }
  };

  const onClickPlan = plan => {
    planChart(plan);
  };

  const onChangePlan = plan => {
    console.log("ClickPlan", plan);
    planChart(plan);
    setModalVisible(true);
  };

  const onChangeSubscription = subscrip => {
    const sub = firebase.functions().httpsCallable("changeSubscription");
    
    sub({
      subscription: props.subscription && props.subscription[0].subscription,
      plan: plan.stripePlan,
      userId: props.subscription && props.subscription[0].userId,
      cancelPeriodUpdate: false
    });
    setModalVisible(false);
  };

  const onCancelModal = () => {
    setModalVisible(false);
    setPlan({
      price: "",
      plan: "",
      stripePlan: "",
      checked: false
    });
  };

  const cancelSubscription = (subscrip, update) => {
    const sub = firebase.functions().httpsCallable("changeSubscription");

    sub({
      subscription: subscrip.subscription,
      plan: subscrip.plan,
      userId: subscrip.userId,
      cancelPeriodUpdate: update
    });
  };

  if (!isLoaded(props.auth)) {
    return (
      <div style={{ marginTop: 200, textAlign: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (isEmpty(props.auth)) {
    return <Redirect to="/login" />;
  }

  return (
    <div>
      <ModalPopUp
        {...props}
        title="Change Subscription Plan"
        message={
          <div>
            <h3>You are changing plan to: </h3> <h2>{plan.plan} plan</h2>
            <span>${plan.price}/mth</span>
          </div>
        }
        modalVisible={modalVisible}
        onModalOk={onChangeSubscription}
        onCancelModal={() => onCancelModal()}
        plan={plan}
      />
      <Profile
        onClickPlan={onClickPlan}
        showDrawer={showDrawer}
        onChangePlan={onChangePlan}
        onClose={onClose}
        drawer={drawer}
        state={plan}
        subscription={props.subscription}
        user={props.user}
        getFieldDecorator={props.form.getFieldDecorator}
        Fields={Fields}
        UserField={UserField}
        cancelSubscription={cancelSubscription}
        {...props}
      />
    </div>
  );
};

const mapStateToProps = ({ firebase, firestore }) => {
  return {
    auth: firebase.auth,
    subscription: firestore.ordered.stripe_customers,
    user: firestore.ordered.users && firestore.ordered.users[0]
  };
};

const WrappedIndex = Form.create({ name: "account" })(Index);

export default compose(
  withFirestore,
  connect(mapStateToProps),
  firestoreConnect(props => {
    return [
      {
        collection: "stripe_customers",
        doc: props.auth.uid || null
      },
      {
        collection: "users",
        where: [["uid", "==", props.auth.uid || null]]
      }
    ];
  })
)(WrappedIndex);
